<template>
  <div class="c-calendar" :class="{'is-active' : index == 1}">
    <div class="c-pdf-settings">
      <div class="c-pdf-settings__label">
        <span>{{ $t('pdf.download.button.label') }}</span>
      </div>
      <div class="c-pdf-settings__button">
        <a
          class="button button--action button--action--pdf button--small"
          :title="$t('generatepdf')"
          @click.prevent="showPdfDialog()"
        >{{ $t('generatepdf') }}</a>
      </div>
    </div>

    <v-week-header :days_of_week="this.days_of_week" :kolonne="this.kolonne"></v-week-header>
    <div class="callout warning" v-if="kolonne.length === 0">{{ $t('weeks.kolonne.empty') }}</div>
    <div class="c-calandar__row" v-for="(item, i) in this.kolonne" :key="i">
      <div class="loading-wrapper" :class="{ 'is-loading' : isLoading }">
        <v-week-row
          :id="i"
          :index="index"
          :kolonne_number="item.id"
          :days_of_week="days_of_week"
          :week_results="week_results"
          :weekday_objects="weekday_objects"
          :holidays="holidays"
          @onEndDragDrop="onEndDragDrop"
        ></v-week-row>
      </div>
    </div>

    <v-pdf-dialog
      :isVisible="pdfDialogIsVisible"
      :kolonne="pdfKolonne"
      :date="pdfWeekStartdate"
      v-model="pdfDialogIsVisible"
    />
    <v-form-message type="error" id="form-error" :message="rescheduleError" :autoCloseTimeout="0" />
  </div>
</template>
<script>
import WeekHeader from "./weekHeader";
import WeekRow from "./weekRow";
import WeekplanPdfDialog from "../../partials/WeekplanPdfDialog";
import FormMessage from "./../../partials/Forms/FormMessage";

export default {
  name: "WeekGroup",

  props: {
    startdate: {
      type: Date,
      default: null
    },
    index: {
      type: Number,
      default: null
    },
    holidays: {
      type: Object,
      default: {}
    }
  },

  components: {
    vWeekHeader: WeekHeader,
    vWeekRow: WeekRow,
    vPdfDialog: WeekplanPdfDialog,
    vFormMessage: FormMessage
  },

  data: function() {
    return {
      kolonne: [],
      weekday_objects: [],
      kolonne_settings: [],
      send_start_date: this.startdate,
      days_of_week: [],
      week_results: [],
      isLoading: true,
      pdfDialogIsVisible: false,
      pdfKolonne: [],
      pdfWeekStartdate: "",
      rescheduleError: null
    };
  },

  created: function() {
    this.createWeek();
  },

  mounted: function() {
    this.getKolonneSettings();
  },

  watch: {
    startdate: function(oldVal, newVal) {
      this.createWeek();
    }
  },

  methods: {
    getKolonneSettings: function(getLastWeek = true) {
      let kolonne = [];

      let promise = this.$api
        .clearParams()
        .addParam(
          "startdate",
          this.$moment(this.startdate)
            .startOf("week")
            .format("YYYY-MM-DD")
        )
        .addParam("active", 1)
        .addParam("withAbsences", false)
        .get("kolonne-settings");

      promise
        .then(response => {
          let data = response.data.data;

          if (data.length === 0) {
            if (getLastWeek) {
              this.getLastWeeksKolonneSettings();
            }
          } else {
            data.forEach(function(item) {
              kolonne.push({
                id: item.kolonne
              });
            });

            this.kolonne = kolonne;
          }
        })
        .catch(error => {
          window.app.$helpers.logger(error);
        })
        .finally(() => {});
    },

    getLastWeeksKolonneSettings: function() {
      let promise = this.$api
        .clearParams()
        .addParam(
          "startdate",
          this.$moment(this.startdate)
            .startOf("week")
            .subtract(7, "days")
            .format("YYYY-MM-DD")
        )
        .addParam("active", 1)
        .addParam("withAbsences", false)
        .get("kolonne-settings");

      promise
        .then(response => {
          let data = response.data.data;
          let settingIds = [];
          if (data.length >= 1) {
            data.forEach(item => {
              settingIds.push(item.id);
            });
          }
          this.duplicateMultipleKolonneSettings(settingIds.join(","));
        })
        .catch(error => {
          window.app.$helpers.logger(error);
        });
    },

    duplicateMultipleKolonneSettings: function(settingIds) {
      let body = {
        target_date: this.$moment(this.startdate)
          .startOf("week")
          .format("YYYY-MM-DD"),
        ids: settingIds
      };

      let promise = this.$api
        .clearParams()
        .post("kolonne-settings/duplicate", body);

      promise
        .then(() => {
          this.getKolonneSettings(false);
        })
        .catch(error => {
          window.app.$helpers.logger(error);
        })
        .finally(() => {});
    },

    createWeek: function() {
      this.days_of_week = [];
      const daycount = 5;
      let currentDate = this.$moment(this.startdate);
      for (let step = 0; step < daycount; step++) {
        let thisDate = currentDate.clone().add(step, "day");
        this.days_of_week.push(thisDate._d);
      }
      this.getWeekEntries();
      this.getWeekDays();
    },

    getWeekDays: function() {
      this.isLoading = true;

      let promise = this.$api
        .clearParams()
        .addParam("startdate", this.$moment(this.startdate).format())
        .addParam(
          "enddate",
          this.$moment(this.startdate)
            .endOf("week")
            .format()
        )

        .get("weekday/multiple");

      promise
        .then(
          (response => {
            this.weekday_objects = response.data.data;
          }).bind(this)
        )
        .catch(
          (error => {
            window.app.$helpers.logger(error);
          }).bind(this)
        )
        .finally(() => {
          this.isLoading = false;
        });
    },

    getWeekEntries: function() {
      this.isLoading = true;

      let promise = this.$api
        .clearParams()
        .addParam("startdate", this.$moment(this.startdate).format())
        .addParam("parked", 0)
        .addParam("byweek", true)
        .get("weekplan");

      promise
        .then(
          (response => {
            this.week_results = response.data.data;
          }).bind(this)
        )
        .catch(
          (error => {
            window.app.$helpers.logger(error);
          }).bind(this)
        )
        .finally(() => {
          this.isLoading = false;
        });
    },

    onEndDragDrop: function(event) {
      this.isLoading = true;
      this.rescheduleError = null;

      let promise;

      if (
        event.to.dataset.parkinglot &&
        parseInt(event.to.dataset.parkinglot) === 1
      ) {
        promise = this.parkEntries(event.from);

        // delete weekdays if we go to parking lot
        if (event.from.dataset.weekdays) {
          let weekdayIds = event.from.dataset.weekdays.split(",");
          weekdayIds.forEach(id => {
            this.deleteWeekDayItem(id);
          });
        }
      } else {
        promise = this.rescheduleEntries(event.from, event.to);
      }

      promise
        .then(() => {
          //
        })
        .catch(error => {
          let response = error.response.data;
          let message = this.$t("weeks.reschedule.error");
          let affectedItems = [];
          if (response.items) {
            response.items.forEach(item => {
              affectedItems.push(item.item);
            });
          }
          this.rescheduleError =
            message +
            "<p><strong>" +
            affectedItems.join("<br>") +
            "</strong></p>";
        })
        .finally(() => {
          this.getWeekEntries();
          this.getWeekDays();
        });
    },

    deleteWeekDayItem: function(id) {
      return this.$api.clearParams().delete("weekday/" + id);
    },

    rescheduleEntries: function(from, to) {
      window.app.$helpers.logger("Rescheduling an entry ...");
      let body = {
        from_date: from.dataset.date,
        from_kolonne: from.dataset.kolonne,
        to_date: to.dataset.date,
        to_kolonne: to.dataset.kolonne
      };

      if (from.dataset.weekdays) {
        window.app.$helpers.logger(
          "Found a weekday comment ...",
          from.dataset.weekdays
        );

        body.weekdays = from.dataset.weekdays;
      }

      return this.$api.clearParams().post("weekplan/reschedule", body);
    },

    parkEntries: function(from) {
      let body = {
        from_date: from.dataset.date,
        from_kolonne: from.dataset.kolonne
      };

      return this.$api.clearParams().post("weekplan/park", body);
    },

    showPdfDialog: function() {
      this.pdfDialogIsVisible = true;
      this.pdfKolonne = this.kolonne;
      this.pdfWeekStartdate = this.startdate;
    },

    getKolonne: function() {
      let promise = this.$api.clearParams().get("kolonne");

      promise
        .then(response => {
          let data = response.data.data;
          let kolonne = [];
          data.forEach(function(item) {
            kolonne.push({
              id: item.number
            });
          });

          this.kolonne = kolonne;
        })
        .catch(error => {
          window.app.$helpers.logger(error);
        });
    }
  }
};
</script>